export  default {
  setMenu(state, payload){
    // console.log("MENU SET", payload);
    state.menu = payload;
  }, 
  setMenuItems(state, payload){
    state.menuItems = payload // this is the raw menu items, includes Hidden items
    console.log("SET MENU ITEMS", state.menuItems)
  }
};